import React from 'react';
import { TourGuideImage } from '../TourGuideImage';
import image from '../images/image2.png';

export const Segment4 = () => (
    <div>
        <TourGuideImage src={image} footnote={"Glass Tears, 1932 by Man Ray"} />
    </div>
);
